import { defineModel } from "../define-model";

export type AdCampaignStatus =
	| "draft"
	| "pending"
	| "active"
	| "paused"
	| "completed"
	| "rejected"
	| "failed";

export type AdCampaign = {
	id: string;
	workspaceId: string;
	projectId: string;
	adAccountId: string;
	name: string;
	goal: string;
	status: AdCampaignStatus;
	budgetType: "daily" | "lifetime";
	budgetAmount: number;
	currency: string;
	startAt: string | null;
	endAt: string | null;
	targeting: { ageMin?: number; ageMax?: number; gender?: string; countries?: string[] };
	sourcePostId: string | null;
	zernioCampaignId: string | null;
	zernioAdId: string | null;
	platformCampaignId: string | null;
	metrics: Partial<
		Record<
			"spend" | "impressions" | "reach" | "clicks" | "ctr" | "cpc" | "cpm" | "conversions",
			number
		>
	>;
	lastSyncedAt: string | null;
	createdById: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		adCampaign: AdCampaign;
	}
}

export const model = defineModel({
	name: "adCampaign",
	load: "lazy",
	indexes: ["projectId"],
	sort: (a, b) => b.createdAt.localeCompare(a.createdAt),
});
